import { useState, useEffect } from 'react';
import { adminAPI } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Info, Calendar, Tag } from 'lucide-react';

export default function VersionPage() {
  const [version, setVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getVersion().then(res => setVersion(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0E518D]" /></div>;
  }

  return (
    <div className="space-y-6" data-testid="version-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Versionsinformation</h1>
        <p className="text-sm text-slate-500 font-body mt-1">Aktuelle Anwendungsversion und Build-Daten</p>
      </div>

      <Card className="border-0 shadow-sm rounded-sm max-w-lg">
        <CardContent className="p-6 space-y-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#0E518D] rounded-sm flex items-center justify-center">
              <Info className="w-6 h-6 text-white" strokeWidth={1.5} />
            </div>
            <div>
              <p className="font-body font-semibold text-slate-900">Mietwagen GB Sylt</p>
              <p className="text-sm text-slate-500 font-body">Affiliate-Landingpage</p>
            </div>
          </div>

          <div className="space-y-3">
            <div className="flex items-center justify-between py-2 border-b border-slate-100">
              <div className="flex items-center gap-2">
                <Tag className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
                <span className="text-sm font-body text-slate-600">Version</span>
              </div>
              <Badge className="font-body bg-[#0E518D] text-white" data-testid="version-number">
                {version?.version || '1.0.0'}
              </Badge>
            </div>
            <div className="flex items-center justify-between py-2 border-b border-slate-100">
              <div className="flex items-center gap-2">
                <Calendar className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
                <span className="text-sm font-body text-slate-600">Build Datum</span>
              </div>
              <span className="text-sm font-body text-slate-900" data-testid="build-date">
                {version?.build_date || '-'}
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
